import { render, staticRenderFns } from "./CommunityHealthInfoDetail.vue?vue&type=template&id=de9b27ac&scoped=true&"
import script from "./CommunityHealthInfoDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHealthInfoDetail.vue?vue&type=style&index=0&id=de9b27ac&prod&scoped=true&lang=css&"
import style1 from "./CommunityHealthInfoDetail.vue?vue&type=style&index=1&id=de9b27ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9b27ac",
  null
  
)

export default component.exports